import { Box } from '@mui/material';
import theme from '../../theme';
import { H3 } from '../atoms/text';
import { CardTitle, H4 } from '../atoms/text/text';

export const KPI = ({ value, unit, description, header }: { value: number, unit?: string, description: string, header?: string }) => {
  return(
    <Box sx={ styles.kpi }>
      { header && 
        <Box>
          <H3>
            { header }
          </H3>
        </Box>
      }
      <Box sx={ styles.value }>
        <CardTitle>
          { unit ? value + " " + unit : value }
        </CardTitle>
      </Box>
      <Box>
        <H4>
          { description } 
        </H4>
      </Box>
    </Box>
  )
};

const styles = { 
  kpi: {
    '@media only screen and (max-width: 800px)': {
      flex: '1 1 auto',
      borderTop: '1px solid',
      borderBottom: '1px solid',  
      borderColor: theme.colors.midGrey,
    },
    flex: 1,
    padding: '4px 8px',
    textAlign: 'flex-start',
    maxWidth: '20%',
    color: theme.colors.darkGrey,
    display: 'flex',
    flexDirection: 'column',
  },
  value: {
    paddingLeft: '2px',
  },
}

